{
  "visitorManagement": {
    "title": "访客管理",
    "description": "查看和管理访客供应商同步状态",
    "filters": {
      "bookingId": "预订ID",
      "vendor": "供应商",
      "syncStatus": "同步状态",
      "all": "全部",
      "synced": "已同步",
      "failed": "失败",
      "unknown": "未知",
      "search": "按联系人姓名搜索"
    },
    "table": {
      "bookingId": "预订ID",
      "contact": "联系人",
      "dates": "日期",
      "status": "状态",
      "note": "备注",
      "bookingDetails": "预订详情",
      "vendor": "供应商",
      "syncStatus": "同步状态",
      "actions": "操作",
      "forceSync": "强制同步",
      "viewDetails": "查看详情",
      "noData": "未找到访客供应商状态",
      "loading": "加载中...",
      "validation": "验证",
      "mirror": "镜像",
      "lastSync": "最后同步"
    },
    "status": {
      "synced": "已同步",
      "failed": "失败",
      "unknown": "未知",
      "registered": "已注册",
      "notRegistered": "未注册"
    },
    "detail": {
      "title": "供应商同步详情",
      "syncDetails": "同步详情",
      "vendor": "供应商",
      "syncStatus": "同步状态",
      "lastContacted": "最后联系",
      "lastSuccessful": "最后成功同步",
      "lastFailed": "最后失败同步",
      "errorMessage": "错误消息",
      "lastSuccessfulRequest": "最后成功请求",
      "lastSuccessfulResponse": "最后成功响应",
      "lastFailedRequest": "最后失败请求",
      "lastFailedResponse": "最后失败响应",
      "never": "从未",
      "close": "关闭",
      "forceSyncTooltip": "强制同步功能即将推出"
    },
    "empty": {
      "noStates": {
        "title": "无供应商状态",
        "description": "尚未与访客管理供应商同步任何预订。"
      },
      "noResults": {
        "title": "未找到结果",
        "description": "尝试调整您的过滤器以找到您要查找的内容。"
      },
      "noPermission": {
        "title": "访问被拒绝",
        "description": "您没有权限查看访客管理数据。请联系您的管理员。"
      }
    },
    "error": {
      "title": "加载访客供应商状态时出错",
      "description": "无法加载访客供应商状态。请重试。"
    }
  }
}
